import {FC} from "react";
import {useLocation} from "react-router-dom";

import {useSidebarItems} from "../../../navigation";
import {PageTemplate} from "../../../layout";
import {BackToButton, Pages} from "../../../back-buttons";
import {SearchPageState} from "../../../search";
import {OperationalSearch} from "./OperationalSearch";

/**
 * The {@link OperationalSearchPage} component provides the page layout plugging
 * in components where needed. It also concerns itself with routing
 * information and extracts what it needs to prepare the {@link OldCommonOrgEntitySearch}
 * component for display.
 *
 * @constructor
 */
export const OperationalSearchPage: FC = () => {
  const location = useLocation<SearchPageState>();
  const query = location.search.match(/query=/i)
    ? new URLSearchParams(location.search).get("query") || ""
    : location.state?.query || "";
  const sidebarItems = useSidebarItems({page: "search"});

  return (
    <PageTemplate
      id={"search-page"}
      title={"Search Page"}
      breadcrumbs={<BackToButton page={Pages.Home} />}
      sidebarItems={sidebarItems}>
      <OperationalSearch query={query} />
    </PageTemplate>
  );
};
